import { FeatureFlagsAttributes, FeatureFlagsConfig, FeatureRawResult, FeatureValue } from '../entities';
import { FeatureFlags } from './FeatureFlags';

export class ServerFeatureFlags implements FeatureFlags {
  loadFeatures(): void {}

  getFeatures(): FeatureFlagsConfig['features'] {
    return {};
  }

  setForcedFeatureValues() {}

  getAttributes(): FeatureFlagsAttributes {
    return {};
  }

  setAttributes() {}

  setIdentifier() {}

  getSplitId() {
    return '';
  }

  setStateUpdateHandler() {}

  isFeatureOn() {
    return true;
  }

  isFeatureOff() {
    return true;
  }

  getFeatureValue<T extends FeatureValue = FeatureValue>(featureName: string, defaultValue?: T): T | null {
    return defaultValue ?? null;
  }

  getFeatureRawResult(): FeatureRawResult<null> {
    return {
      value: null,
      source: 'defaultValue',
      on: true,
      off: true,
      ruleId: '',
    };
  }

  getExperimentGroup() {
    return null;
  }

  getAllExperimentsGroup(): Record<string, string> {
    return {};
  }

  onTrackExperiment() {}

  onFeatureUsage() {}

  onFeaturesUpdated() {}

  onFeaturesLoaded() {}

  onFeaturesLoadingFailed() {}

  onAttributesUpdated() {}
}
